import React, { useState, useEffect } from 'react'
import {
    Badge,
    Breadcrumbs,
    Button,
    Checkbox,
    Collapse,
    FormControl,
    FormControlLabel,
    InputBase,
    Grid, IconButton, InputAdornment, InputLabel, Link, OutlinedInput, Paper, Select, Tab, Tabs, TextField, Typography,
    FormHelperText
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import SearchGrid from '../../../components/table/SearchGrid';
import Breadcrums from '../../../components/BreadCrums/breadcrums';
import TopSpacer from '../../../components/Common/spacer/TopSpacer';

import TrackingClaimed from "../../../assets/img/icons/trackingClaimed.svg";
import TrackingConfirmed from "../../../assets/img/icons/trackingConfirmed.svg";
import TrackingDeleted from "../../../assets/img/icons/trackingDeleted.svg";
import TrackingDelivered from "../../../assets/img/icons/trackingDelivered.svg";
import TrackingReturned from "../../../assets/img/icons/trackingReturned.svg";
import TrackingShipped from "../../../assets/img/icons/trackingShipped.svg";
import TrackingTransit from "../../../assets/img/icons/trackingTransit.svg";
import TrackingVoid from "../../../assets/img/icons/trackingVoid.svg";
import { GetUserInfo } from '../../../Services/GetUserInfo';
import { PostDataAPI } from '../../../Services/APIService';
import CreateShippingLabel from './createShippingLabel/CreateShippingLabel';
import AddManualTracking from './addManualTracking/AddManualTracking';
import ViewShippingDetails from './viewShippingDetails/ViewShippingDetails';
import ViewPrint from './viewPrint/ViewPrint';
import StatusSummary from './statusSummary/StatusSummary';

import { formatDate, formateMdnNumber, numberDisplay, getFormatedDate, orderTrackStatus, formatDateTime, formatDateTime2, getLocalDateFromUTC } from '../../../../src/components/Common/Extensions';
import Loader from './../../../components/Loader/Loader';
import { ActionDialog } from "./../../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "./../../../components/Message/Alert";
import moment from 'moment';
import { useLocation, useParams, useHistory } from "react-router-dom";

function DomesticTracking({ trackingType, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    let history = useHistory();
    const [historyTrackingNumber, setHistoryTrackingNumber] = useState(history.location?.state?.trackingNumber);
    const [orderTrackShipmentInfo, setOrderTrackShipmentInfo] = useState();
    const [trackLabelImage, setTrackImageLabel] = useState('');
    const [lastSyncDate, setLastSyncDate] = useState();
    const [type, setType] = useState(trackingType ? trackingType :'domesticTracking');
    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })
    const [shippingDetails, SetShippingDetails] = useState(false);

    const [statusDialogSummary, setStatusDialogSummary] = useState(false);

    const statusDialogSummaryClose = () => {
        setStatusDialogSummary(false)
    }

    const statusDialogSummaryOpen = () => {
        setStatusDialogSummary(true)
    }

    const openShipmentDetailsDialog = () => {
        SetShippingDetails(true)
    }
    const closeShipmentDetailsDialog = () => {
        SetShippingDetails(false)
    }
    const [viewShipmentLabelPrint, setViewShipmentLabelPrint] = useState(false);
    const openShipmentLabelPrintDialog = () => {
        setViewShipmentLabelPrint(true)
    }
    const closeShipmentLabelPrintDialog = () => {
        setViewShipmentLabelPrint(false)
    }
    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }

    const [errorMessages, setErrorMessages] = useState({});

    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const [state, setState] = useState({
        confirmed: '', shipped: '', inTransit: '', delivered: '', returned: '',
        claimed: '', voided: '', deleted: ''
    });
    const [orderTracking, setOrderTracking] = useState([]);
    const [filteredOrderTracking, setFilteredOrderTracking] = useState([{}]);
    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [shippingLabelDialog, setShippingLabelDialog] = useState(false);
    const [addManualTracking, setAddManualTracking] = useState(false);

    const [validated, setValidated] = useState(false);

    const closeManualTrackingDialog = () => {
        setAddManualTracking(false)
    }

    const openManualTrackingDialog = () => {
        setOrderTrackShipmentInfo({});
        setAddManualTracking(true)
    }

    const closeShippinglabelDialog = () => {
        setShippingLabelDialog(false);
    }

    const handleSuccessClose = (message) => {
        setType('')
        setOrderTrackShipmentInfo({});
        setAddManualTracking(false)
        setShippingLabelDialog(false);
        showMessage("Success", message, "success", 3000);
        loadShipmentGrid();
    }

    const openShippinglabelDialog = () => {
        setType(trackingType);
        setOrderTrackShipmentInfo({});
        setShippingLabelDialog(true);
    }

    const openShippingReturnLabelDialog = () => {
        setType(trackingType);
        setOrderTrackShipmentInfo({});
        setShippingLabelDialog(true);
    }

    const DomesticOrderTrackingTest = [
        {
            CreatedBy: "Sarah",
            TrackingNumber: "1Z224F540395382703",
            FullName: "John Doe",
            PhoneNumer: "(919) 675-0932",
            Status: "Shipper Created A Label, UPS",
            LastScan: "Monday, January 30, 2023 06:00 PM",
        }
    ]

    const statusCheckbox = [
        {
            value: 'Confirmed',
            status: 'M',
            numbers: '00',
            Icon: TrackingConfirmed,

        },
        {
            value: 'Shipped',
            status: 'P',
            numbers: '00',
            Icon: TrackingShipped,

        },
        {
            value: 'In Transit',
            status: 'I',
            numbers: '00',
            Icon: TrackingTransit,

        },
        {
            value: 'Delivered',
            status: 'D',
            numbers: '00',
            Icon: TrackingDelivered,

        },
        {
            value: 'Returned',
            status: 'RS',
            numbers: '00',
            Icon: TrackingReturned,

        },
        {
            value: 'Claimed',
            status: 'Claimed',
            numbers: '00',
            Icon: TrackingClaimed,

        },
        {
            value: 'Void',
            status: 'MV',
            numbers: '00',
            Icon: TrackingVoid,

        },
        //{
        //    value: 'Deleted',
        //    status: 'Deleted',
        //    numbers: '00',
        //    Icon: TrackingDeleted,
        //},

    ]
    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }

    const syncTrackingRecord = () => {
        setIsLoading(true);
        PostDataAPI("ordertracking/updateShipmentActivityStatuses", {}, true)
            .then((result) => {
                setIsLoading(false);
                if (result.success) {
                    loadShipmentGrid();
                    loadLastSyncDate();
                } else {
                    showMessage("Error", "Syncing failed, please try again", "error", 3000);
                }
            });
    }

    const loadLastSyncDate = () => {
        var params = {
            code: 'get_last_sync',
            parameters: ['UPS','last_sync']
        };

        PostDataAPI("ddl/loadItems", params).then((result) => {
            if (result.success && result.data != null && result.data.length > 0) {
                try {
                    setLastSyncDate(result.data[0].last_sync_date ? formatDateTime2(getLocalDateFromUTC(result.data[0].last_sync_date)) : formatDateTime2(new Date()));
                } catch (error) {
                    setLastSyncDate('');
                }
                
            }
        })
    }

    const loadShipmentGrid = () => {
        var obj = { trackingType: trackingType};
        setIsLoading(true);
        PostDataAPI("ordertracking/loadShipmentTrackingGrid", obj).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                var orderTackingList = result.data.map((item, i) => {
                    item.statusLabel = orderTrackStatus(item.status);
                    item.shipPhone = formateMdnNumber(item.phone);
                    item.lastScanned = formatDate(item.lastScanDateTime) + '  ' + getFormatedDate(item.lastScanDateTime,'hh:mm A')
                    return { ...item }
                });
                setOrderTracking(orderTackingList);
                if (filteredStatus.length > 0) {
                    setFilteredOrderTracking(orderTackingList.filter(o => filteredStatus.some(s => s == o.status)));
                }
                else {
                    setFilteredOrderTracking(orderTackingList);
                }
                setValue(historyTrackingNumber ? historyTrackingNumber : '');
                handleDataGridUpdate();
                
                   
            } else {
                setOrderTracking([]);
                setFilteredOrderTracking([]);
                handleDataGridUpdate();
            }

        })
    }

    const [filteredStatus, setFilteredStatus] = useState(['I']);
    const handleStatusClick = (event, status) => {
        var lstStatus = filteredStatus;
        if (event.target.checked) {
            lstStatus.push(status);
        }
        else {
            lstStatus = lstStatus.filter(s => s != status)
        }
        setFilteredStatus(lstStatus);
        if (lstStatus.length > 0) {
            setFilteredOrderTracking(orderTracking.filter(o => lstStatus.some(s => s == o.status)));
        }
        else {
            setFilteredOrderTracking(orderTracking);
        }

        handleDataGridUpdate();
    }
    const handleActionClick = (key, item) => {
        if (key == 'delete') {
            showActionDialog("Once deleted, this shipment order will be Voided from UPS. Are you sure you want to delete this order tracking?", "confirm", function () {
                deleteCustomerOrder(item);
            });
        } else if (key == 'updateRecord') {
            setType(item.type)
            setOrderTrackShipmentInfo(item)
            setAddManualTracking(false)
            setShippingLabelDialog(true);
        }
        else if (key == 'details') {
            setOrderTrackShipmentInfo(item)
            openShipmentDetailsDialog();
        }
        else if (key == 'statusSummary') {
            setOrderTrackShipmentInfo(item)
            setStatusDialogSummary(true);
        }
        else if (key == 'printLabel') {
            if (item.graphicImage && item.graphicImage.length > 0) {
                setOrderTrackShipmentInfo(item)
                setAddManualTracking(false)
                setViewShipmentLabelPrint(true)
            } else {
                if (item.status == 'D') {
                    showMessage("Error", "Label is unavailable -- all the packages of the shipment have been sent to the destination address", "error", 3000);
                } else {
                    showMessage("Error", "Label is unavailable", "error", 3000);
                }
            }
        }
    }

    const deleteCustomerOrder = (item) => {
        var params = {
            trackingId: item.trackingId + ""
        }
        setIsLoading(true)
        PostDataAPI("ordertracking/deleteShipmentTrackingDetails", params).then((result) => {
            setIsLoading(false)
            if (result.success) {
                showMessage("Success", "Record deleted successfully", "success", 3000);
                loadShipmentGrid();
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
        })
    }
    const handleSuccessInquiryNumberValidation = (_record, trackingNumber) => {
        setType(trackingType)
        var inquiryNumber = trackingNumber;
        var shipment = _record?.shipment;
        var orderState = '';
        var orderLastScanDate = '';
        var orderLastScanTime = '';
        var lastScanDateTime = '';
        if (shippingDetails != null && shippingDetails.package != null) {
            orderState = shipment[0]?.package[0]?.activity[0]?.status?.type;
            orderLastScanDate = shipment[0]?.package[0]?.activity[0]?.date;
            orderLastScanTime = shipment[0]?.package[0]?.activity[0]?.time;
            lastScanDateTime = moment(orderLastScanDate + ' ' + orderLastScanTime, 'YYYYMMDD HHmmss').toDate();
        }
       

        const params = {
            trackingNumber: inquiryNumber,
            lastScanDateTime: lastScanDateTime,
            status: orderState ? orderState : ''
        }
        setOrderTrackShipmentInfo(params)
        setAddManualTracking(false)
        setShippingLabelDialog(true);
    }

    const validateReset = () => {
        setType('')
        setValidated(false)
    }
    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataGridUpdate()
        }
    }
    // Function to clear the input field
    const handleClearInput = (name) => {
        setValue('');
        setHistoryTrackingNumber('');
        handleDataGridUpdate();
    };

   

    useEffect(() => {
        loadShipmentGrid();
        loadLastSyncDate();
    }, [trackingType]);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Shipping & Tracking"} isBack={true} currentLink={trackingType == 'domesticTracking'?'Domestic':trackingType == 'returnLabel'?'Return Label':'International'}></Breadcrums>
                    </Grid>
                </Grid>
            </div>

            <Grid container className={classes.container}>
               
            </Grid>

            <Grid container row className={classes.container}>

                <div className={classes.statusBoxContainer}>

                    {statusCheckbox.map((item, i) => (
                        <>
                            <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        checked={filteredStatus.filter(value => value === item.status).length > 0? true:false}
                                        onClick={(e) => { handleStatusClick(e, item.status) }}
                                    />
                                }
                                label={<>
                                    <div className={item.status == "M" ? classes.statusBoxes + " " + "Confirmed" :
                                        item.status == "P" ? classes.statusBoxes + " " + "Shipped" :
                                            item.status == "I" ? classes.statusBoxes + " " + "InTransit" :
                                                item.status == "D" ? classes.statusBoxes + " " + "Delivered" :
                                                    item.status == "RS" ? classes.statusBoxes + " " + "Returned" :
                                                        item.status == "Claimed" ? classes.statusBoxes + " " + "Claimed" :
                                                            item.status == "Deleted" ? classes.statusBoxes + " " + "Deleted" :
                                                                item.status == "MV" ? classes.statusBoxes + " " + "Void" : ''


                                    }>
                                        <img src={item.Icon} />
                                        <div className={classes.statusBoxContent}>
                                            <h3>{item.value}</h3>
                                            {item.status == "Deleted" ? <h2>{orderTracking?.filter(t => t.isDeleted).length}</h2>
                                                : <h2>{orderTracking?.filter(t => t.status == item.status).length}</h2>}

                                        </div>

                                    </div>
                                </>}
                            />
                        </>
                    ))}

                </div>

            </Grid>

            <Grid row className={classes.gridHeader}>

                <div className={classes.gridActions} style={{ marginRight: 'auto' }} >
                    <Button className={classes.changeBtn} onClick={syncTrackingRecord} >Sync Data</Button>
                    {lastSyncDate ? <span className={classes.lastSeen}>Last Synced: {lastSyncDate ? lastSyncDate : ''}</span> : ''}
                
                </div>
                
                <div className={classes.gridActions}>
          
                    {trackingType == 'domesticTracking' ? <>
                        <Button className={classes.changeBtn} onClick={openShippinglabelDialog} >Create Shipping Label</Button>
                        <Button className={classes.changeBtn} onClick={openManualTrackingDialog}>Add Manual Shipping</Button>
                    </> : trackingType == 'returnLabel' ? <Button className={classes.changeBtn} onClick={openShippingReturnLabelDialog} >Create Return Label</Button>:''}
                 
                    </div>

                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        endAdornment={searchFilter ? <ClearIcon style={{cursor: 'pointer'}} onClick={() => { handleClearInput('search') }} /> : ''}
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}
                    />
                </div>
            </Grid>

            <Grid row className={classes.container} >
                <SearchGrid columns="DomesticOrderTracking"
                    list={filteredOrderTracking}
                    noRecordMsg="No tracking exists"
                    Icon={true}
                    onActionClick={handleActionClick}
                    isUpdate={isDataGridUpdate}
                    filter={searchFilter}
                />
            </Grid>

            {shippingLabelDialog ?
                <CreateShippingLabel
                    dialogOpenClose={shippingLabelDialog}
                    handleClose={closeShippinglabelDialog}
                    trackNumberDetails={orderTrackShipmentInfo}
                    trackingType={trackingType}
                    handleSuccessClose={handleSuccessClose}
                ></CreateShippingLabel> :
                ''}

            {shippingDetails ?
                <ViewShippingDetails
                    dialogOpenClose={shippingDetails}
                    handleClose={closeShipmentDetailsDialog}
                    orderId={orderTrackShipmentInfo.orderId}
                >
                </ViewShippingDetails>
                : ''
            }

            {statusDialogSummary ?
                <StatusSummary
                    dialogOpenClose={statusDialogSummaryOpen}
                    handleClose={statusDialogSummaryClose}
                    trackNumberDetails={orderTrackShipmentInfo}>
                </StatusSummary> : ''
            }

            {addManualTracking ?
                <AddManualTracking
                    dialogOpenClose={addManualTracking}
                    handleClose={closeManualTrackingDialog}
                    successInquiryNumber={handleSuccessInquiryNumberValidation}
                ></AddManualTracking> : ''}
            {viewShipmentLabelPrint ?
                <ViewPrint
                    dialogOpenClose={viewShipmentLabelPrint}
                    handleClose={closeShipmentLabelPrintDialog}
                    trackNumberDetails={orderTrackShipmentInfo} >

                </ViewPrint>
                : ''}


            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

        </>
    )

}

export default withSnackbar(DomesticTracking);